import { SecurityServerStatusWebComponent } from './component/SecurityServerStatusWebComponent';

export { SecurityServerStatusWebComponent };
